import { split } from "../../lib/ui.ts";

export function Split({
  spaced,
  className,
  children,
}: {
  spaced?: boolean;
  className?: string;
  children: React.ReactNode;
}) {
  const base = spaced ? `${split} mt-8` : split;
  const classes = className ? `${base} ${className}` : base;
  return <div className={classes}>{children}</div>;
}
